<template>
  <div>
    <div class="bg_wx" v-if="wx">
        <h1>请点击右上角，选择在浏览器中打开</h1>
        <div class="bg_wx2"></div>
        <div class="bg_wx3">
            <div class="item bg_wx4"></div>
            <div class="item">
                <h1>爱股票APP</h1>
                <p>专业投资者社区</p>
            </div>
        </div>
    </div>
    <div class="bg_else" v-else>
        <div class="bg_wx4"></div>
        <div class="btn" @click="down">下载爱股票APP</div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            wx:true,
            v:this.$route.query.v||'',
            name:this.$route.query.name||'',
        }
    },
    created(){
        var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            this.wx = true;
        }else{
            this.wx = false;
        }
        this.init();
        //this.wx = true;
    },
    methods:{
        down(){
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                // ios设备跳转到应用宝
                // https://itunes.apple.com/cn/app/qq/id1462628088
                location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui';
            }
            else{
                //安卓直接下载
                //需要一个下载链接
                location.href = 'https://cdncos.aigupiao.com/download/aigupiao/11.7.1/AiGuPiao20240821a_promotion_v11.7.1_signed.apk';
            }
        },
        //进来就调用接口 记录访客
        init(){
            //https://appdev.aigupiao.com/api/app_download_statistics.php
            $.ajax({
                xhrFields: { withCredentials: true },
                type: "get",
                url: `https://app${this.CURRENT_ENV_PRE}.aigupiao.com/api/app_download_statistics.php?v=${this.v}&name=${this.name}`,
                cache: false,
                async: true,
                error: function () {
                    return false;
                },
                success: function (data) {
                    console.log(data);
                },
            })
        }
    },
    computed:{
        CURRENT_ENV_PRE(){
            let host0 = window.location.href;
            if(host0.indexOf("80") > 0) return "dev";//vue项目 本地调试设置变量
            if (host0.indexOf("dev") > 0) return "dev";
            if (host0.indexOf("beta") > 0) return "beta";
            return '';
        }
    },
}
</script>

<style scoped lang="scss">
.bg_wx{
    color: #fff;
    width: 100vw;
    min-height: 100vh;
    background-size: 100%;
    background-image: url(https://cdncos.aigupiao.com/assets/pc/img/2023/app1bg.png);
    >h1{
        font-size: 15px;
        text-align: center;
        padding: 60px 0 80px;
    }
    .bg_wx2{
        width: 345px;
        height: 370px;
        flex-shrink: 0;
        background-size: 100%;
        background-image: url(https://cdncos.aigupiao.com/assets/pc/img/2023/app1bg2.png);
        margin: 0 auto 30px;
        
    }

    .bg_wx3{
        display: flex;
        align-items: center;
        justify-content: center;

        .bg_wx4{
            width: 46px;
            height: 46px;
            flex-shrink: 0;
            background-size: 100%;
            background-image: url(https://cdncos.aigupiao.com/assets/pc/img/2023/app1bg3.png);
            margin-right: 15px;
        }
        .item{

            >h1{
                font-size: 18.195px;
                font-style: normal;
                font-weight: 500;
                margin-bottom: 10px;
            }
            >p{
                font-size: 14.449px;
                font-style: normal;
                font-weight: 400;
            }
        }

    }
}
.bg_else{
    background: #fff;
    min-height: 100vh;
    overflow: hidden;
    .bg_wx4{
        width: 70px;
        height: 70px;
        flex-shrink: 0;
        background-size: 100%;
        background-image: url(https://cdncos.aigupiao.com/assets/pc/img/2023/app1bg3.png);
        margin: 200px auto 0 ;
    }
    .btn{
        background: #fff;
        width: 145px;
        display: flex;
        height: 40px;
        padding: 10px;
        box-sizing: border-box;
        justify-content: center;
        align-items: center;
        margin: 20px auto;
        flex-shrink: 0;
        border-radius: 6px;
        border: 1px solid #FF443D;
        color: #FF443D;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
}
</style>